/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../../message';
import { IDescriptorBody } from '../../../descriptor';
import CommentThreadAddedCommentDescriptor, { ICommentThreadAddedComment } from '../../descriptors/commentthreadaddedcomment';

export interface IAddedComment {
	commentId: string;
	createdAt: string;
}

export interface IAddCommentThreadResponse extends IMessage {
	commentThreadId: string;
	createdAt: string;
	comments: IAddedComment[];
}

export default class AddCommentThreadResponse extends Message {
	public readonly createdAt: Date;

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2AddCommentThreadResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			createdAt: {
				type: 'string',
				id: 2
			},
			comments: {
				type: 'CommentThreadAddedCommentDescriptor',
				rule: 'repeated',
				id: 3
			}
		}
	};

	public constructor(
		public readonly commentThreadId: string,
		createdAt: string,
		public comments: ICommentThreadAddedComment[] = []
	) {
		super();

		this.createdAt = new Date( createdAt );
	}

	public toJSON(): IAddCommentThreadResponse {
		return {
			commentThreadId: this.commentThreadId,
			createdAt: this.createdAt.toISOString(),
			comments: this.comments.map( comment => CommentThreadAddedCommentDescriptor.toJSON( comment ) )
		};
	}

	public static fromJSON( data: IAddCommentThreadResponse ): AddCommentThreadResponse {
		return new AddCommentThreadResponse(
			data.commentThreadId,
			data.createdAt,
			data.comments.map( comment => CommentThreadAddedCommentDescriptor.fromJSON( comment ) )
		);
	}
}
